module.exports = __webpack_public_path__ + "static/media/key.e611baf3.svg";